import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-sort-order-dialog',
  templateUrl: './sort-order-dialog.component.html',
  styleUrls: ['./sort-order-dialog.component.css']
})
export class SortOrderDialogComponent implements OnInit {

  backupColumnData: Array<any>;
  columnData: Array<SortModel>;
  selectedSortFields: Array<SortModel> = [];
  selectedSortField: SortModel;

  constructor(public dialogRef: MatDialogRef<SortOrderDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private authService: AuthService) {
    this.backupColumnData = JSON.parse(JSON.stringify(data['tableColumns']));
    this.initSortField();

    this.addPreviouslySelectedSortFields(data);
  }

  private initSortField() {
    this.columnData = this.backupColumnData.map(row => {
      return new SortModel(row.key, row.name, SortOrder.ASCENDING);
    }).sort((a, b) => {
      return a.label.localeCompare(b.label);
    });

  }

  private addPreviouslySelectedSortFields(data) {
    this.selectedSortFields = JSON.parse(JSON.stringify(data['sortedColumns']));
    this.selectedSortFields.forEach(row => {
      const sortEntry = this.columnData.find(col => col.key === row.key);
      if (sortEntry) {
        this.columnData.splice(this.columnData.indexOf(sortEntry), 1);
      }
    });
  }

  ngOnInit() {
    if (this.authService.isTestUser === undefined) {
      this.authService.isTestingUser().subscribe(isTestUser => {
        if (!isTestUser) {
          this.removeDevColumns();
        }
      });
    } else if (!this.authService.isTestUser) {
      this.removeDevColumns();
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedSortFields, event.previousIndex, event.currentIndex);
  }

  onAddFilterClicked() {
    if (this.selectedSortField) {
      this.selectedSortFields.push(this.selectedSortField);
      this.columnData.splice(this.columnData.indexOf(this.selectedSortField), 1);

      this.selectedSortField = undefined;
    }
  }

  onSortClicked() {
    this.dialogRef.close(this.selectedSortFields);
  }

  onResetClicked() {
    this.selectedSortFields = [];
    this.initSortField();
  }

  removeColumn(column: SortModel) {
    this.selectedSortFields.splice(this.selectedSortFields.indexOf(column), 1);
    this.columnData.push(column);
    this.columnData.sort((a, b) => a.label.localeCompare(b.label));
  }


  private removeDevColumns() {
    const skuId = this.columnData.find(col => col.key === 'SKU_id');
    if (skuId) {
      this.columnData.splice(this.columnData.indexOf(skuId), 1);
    }

    const locProductCd = this.columnData.find(col => col.key === 'Loc_Product_cd');
    if (locProductCd) {
      this.columnData.splice(this.columnData.indexOf(locProductCd), 1);
    }
  }
}

export class SortModel {
  constructor(
    public key?: string,
    public label?: string,
    public sortOrder?: SortOrder
  ) {
  }
}

export enum SortOrder {
  ASCENDING,
  DESCENDING
}
